import React from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';
import Breathing from '~/App/Components/Shared/Breathing';
import CallToAction from './CallToAction';
import { PreviewProps } from '../../LandingPagePreview';

const StyledAuthorName = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${colours.blue};
  margin-bottom: 10px;
`;

const StyledMessageText = styled.div`
  white-space: normal;
  font-size: 12px;
  color: ${colours.greyDarkAlt3};
  word-break: break-word;
`;

const StyledMessageItems = styled.div``;

interface StyledWrapperProps {
  compact: boolean;
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  text-align: left;
  padding-bottom: 10px;
  padding-top: 13px;
  animation: slide-up 0.4s ease;

  ${(props) => {
    if (props.compact) {
      return `
        padding-top: unset;

        ${StyledAuthorName} {
          margin-bottom: 0;
        }
        ${StyledMessageItems} {
          padding-left: 5px;
          border-left: 0.2em solid ${colours.blue};
        }
      `;
    }
  }}
`;

const StyledCTABtnWrapper = styled.div`
  display: block;
  font-size: 12px;
  text-align: left;
`;

export interface MessageContentProps
  extends Pick<
    PreviewProps,
    | 'message'
    | 'userShortName'
    | 'highlight'
    | 'ctaUrl'
    | 'secondaryColor'
    | 'ctaText'
    | 'showCta'
    | 'color'
  > {
  mode?: 'compact' | 'default';
}

const MessageContent = (props: MessageContentProps) => {
  const {
    message,
    userShortName,
    highlight,
    ctaUrl,
    secondaryColor,
    ctaText,
    showCta,
    color,
    mode = 'default',
  } = props;

  return (
    <StyledWrapper compact={mode === 'compact'}>
      <StyledAuthorName>{userShortName}</StyledAuthorName>
      <StyledMessageItems>
        <StyledMessageText>{message}</StyledMessageText>
        <StyledCTABtnWrapper>
          <Breathing
            componentClass={CallToAction}
            active={highlight === 'cta'}
            ctaUrl={ctaUrl}
            ctaText={ctaText}
            showCta={showCta}
            color={color}
            ctaBgColor={secondaryColor}
          />
        </StyledCTABtnWrapper>
      </StyledMessageItems>
    </StyledWrapper>
  );
};

export default MessageContent;
